/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, all, put, takeLeading, select } from 'redux-saga/effects'
import { createSagas } from 'src/helpers/redux'
import store from 'src/store'
import { realtimeService } from 'src/services/realtime'
import { selectors } from './selectors'
import { IResponse } from 'src/services/mail/http'
import { setters } from './index'
import * as Account from '../account'

import { actions, Actions, PREFIX } from './actions'

import * as notificationService from 'src/services/notifications'
import { IStateData } from './state'

export default createSagas<Actions>(actions, {
  getNotifications: function* ({ payload }) {
    const notifications: IResponse<notificationService.IGetNotificationsData> =
      yield call(notificationService.getNotifications, payload)

    if (payload.cursor) {
      yield put(
        setters.setNotificationsAppendMore({
          items: notifications.data,
          // @ts-ignore
          nextCursor: notifications?.meta?.cursor?.next,
        })
      )
    } else {
      yield put(
        setters.setNotifications({
          items: notifications.data,
          // @ts-ignore
          nextCursor: notifications?.meta?.cursor?.next,
        })
      )
    }
  },
  getNotificationsCount: function* ({ payload }) {
    const user: Account.IStateData['user'] = yield select(
      Account.selectors.selectors.user
    )

    const notificationsCount: IResponse<notificationService.IGetNotificationsCountData> =
      yield call(notificationService.getNotificationsCount, payload)

    realtimeService.only<notificationService.INotification>(
      {
        key: `notifications`,
        params: user?.id?.toString(),
        channel: 'notifications:user',
      },
      (data) => {
        store.dispatch(setters.setNotificationsAppend(data))
      }
    )

    yield put(setters.setNotificationsCount(notificationsCount.data.count))
  },
  postNotificationsMarkAsRead: function* ({ payload }) {
    const notifications: IStateData['notifications'] = yield select(
      selectors.notifications
    )

    const notificationIds = notifications.items
      .filter((item) => !item.isRead)
      .map((item) => item.id)
    if (notificationIds.length) {
      yield call(notificationService.postNotificationsMarkAsRead, {
        notificationIds,
      })

      yield put(setters.setNotificationsMarkAsRead({ ids: notificationIds }))
    }
  },

  // getAllComments: function* ({ payload }) {
  //   const allComments: IResponse<ICommentData[]> = yield call(getAllComments, {
  //     ...payload,
  //   })

  //   const listKey = `${PREFIX}`
  //   const channel = `storage:${payload.objectScheme}:comments`

  //   realtimeService.only<ICommentData>(
  //     {
  //       key: `${listKey}/insert`,
  //       event: 'insert',
  //       channel,
  //     },
  //     (data) => {
  //       if (data.parentCommentId) {
  //         store.dispatch(
  //           setters.setReplyToComment({
  //             data: data,
  //             parentId: data.parentCommentId,
  //           })
  //         )
  //       } else {
  //         store.dispatch(setters.setPostedComment({ ...data, replies: [] }))
  //       }
  //     }
  //   )

  //   realtimeService.only<ICommentData>(
  //     {
  //       key: `${listKey}/resolve`,
  //       event: 'resolve',
  //       channel,
  //     },
  //     (data) =>
  //       store.dispatch(
  //         setters.setResolvedComment({
  //           uniqId: data.uniqId,
  //           schemeName: payload.objectScheme || '',
  //           commentId: data.id,
  //         })
  //       )
  //   )

  //   realtimeService.only<ICommentData>(
  //     {
  //       key: `${listKey}/delete`,
  //       event: 'update',
  //       channel,
  //     },
  //     (data) => store.dispatch(setters.setDeleteComment(data))
  //   )

  //   yield put(setters.setComments(allComments))
  // },
})
